import React from 'react'
import Layout from './Layout'
import WnoidaSection from '../Wnoida/Wnoida'
const Layouts = () => {
  return (
    <>
     <div className='aboutus'>
        <Layout/>
        <WnoidaSection/>
        </div>
    </>
  )
}

export default Layouts